import { EnumAppointmentReminderStatus } from "@bbj-types/action/appointmentReminder";
import type { SvgIconComponent } from "@mui/icons-material";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import NotificationsOffOutlinedIcon from "@mui/icons-material/NotificationsOffOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";

interface IReminderStatusDescriptor {
  icon: SvgIconComponent;
  color: string;
  /** Short text displayed inline, next to the other action details (agenda view) */
  label: string;
  /** Detailed explanation displayed in the popover opened from the action date (list view) */
  message: string;
}

export const reminderStatusMapping: Record<EnumAppointmentReminderStatus, IReminderStatusDescriptor> = {
  [EnumAppointmentReminderStatus.NOT_SCHEDULED]: {
    icon: NotificationsOffOutlinedIcon,
    color: "action.disabled",
    label: "Pas de message programmé",
    message:
      "Pas d'envoi de message de rappel programmé avant le rendez-vous. Pour activer l'option, modifiez l'action et activez la.",
  },
  [EnumAppointmentReminderStatus.SCHEDULED]: {
    icon: NotificationsOutlinedIcon,
    color: "primary.main",
    label: "Message de rappel programmé",
    message: "Envoi automatique d'un message de rappel 24h avant le rendez-vous au candidat.",
  },
  [EnumAppointmentReminderStatus.SENT]: {
    icon: NotificationsActiveOutlinedIcon,
    color: "success.main",
    label: "Message de rappel envoyé",
    message: "Le message de rappel a bien été envoyé 24h avant le rendez-vous au candidat.",
  },
  [EnumAppointmentReminderStatus.FAILED]: {
    icon: NotificationImportantOutlinedIcon,
    color: "error.main",
    label: "Erreur d'envoi du message programmé",
    message: "Erreur d'envoi du message de rappel en raison d'une erreur système.",
  },
};
